import Avatar from './components/Avatar';
import React, { useState } from 'react';

const RANK_THEMES = [
  { background: 'linear-gradient(135deg, #58616d, #232931)', accent: '#f4f7fb' },
  { background: 'linear-gradient(135deg, #1a8f4b, #064c2b)', accent: '#baffd4' },
  { background: 'linear-gradient(135deg, #087fba, #073d75)', accent: '#bcecff' },
  { background: 'linear-gradient(135deg, #783ec7, #32116d)', accent: '#ead5ff' },
  { background: 'linear-gradient(135deg, #e19012, #7c3500)', accent: '#fff0a8' },
];

const Leaderboard = ({ leaderboard, rankData }) => {
  const [currentRankIndex, setCurrentRankIndex] = useState(0);




  const currentRank = rankData[currentRankIndex] || {}; // Защита от пустых данных
  const { name: rankName, image, image_url: imageUrl, text_color: textColor, background, linear_background: linearBackground } = currentRank;
  const currentRankUsers = leaderboard?.[rankName] || [];
  const theme = RANK_THEMES[currentRankIndex % RANK_THEMES.length];
  const foreground = textColor || theme.accent;

  return (
    <div className="container_">
      <div className="Leaderboard">
        <div
          className="Lidbord"
          style={{
            background: linearBackground || background || theme.background,
            color: foreground,
          }}
        >
          <div
            onClick={() => setCurrentRankIndex(prev => Math.max(prev - 1, 0))}
            className="Tuda"
            style={{ color: foreground }}
          >
            &larr;
          </div>

          <div className="Rank_Infor">
            {(image || imageUrl) ? (
              <img src={image || imageUrl} alt={rankName} className="rank-images" style={{ borderColor: foreground }} />
            ) : (
              <div className="rank-images" aria-label={rankName}>🏅</div>
            )}
            <p className="rank-name" style={{ color: foreground }}>{rankName}</p>
            <p className="rank-description" style={{ color: foreground }}>До {Number(currentRank.max_clicks || 0).toLocaleString('ru-RU')} кликов</p>
          </div>

          <div
            onClick={() => setCurrentRankIndex(prev => Math.min(prev + 1, rankData.length - 1))}
            className="Suda"
            style={{ color: foreground }}
          >
            &rarr;
          </div>
        </div>

        <div className="leaderboard-scroll">
  {currentRankUsers.length > 0 ? (
    <table className="leaderboard-table">
      <tbody>
        {currentRankUsers.slice(0, 30).map((leader, index) => ( 
          <tr key={index} className="leaderboard-row">
            <td className="user-info">
              <span className="user-rank">{index + 1}</span>
              <Avatar userId={leader.id} src={leader.avatar_url} alt={leader.username} />

              <div className='frendly'>
                <span className="username">
                  {leader.username.length > 15 ? leader.username.slice(0, 15) + '...' : leader.username}
                </span>
                <span className="clicks">{Number(leader.click_count).toLocaleString('ru-RU')} кликов</span>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>Список пуст, но вы могли бы стать первым!</p>
  )}
</div>

      </div>
    </div>
  );
};

export default Leaderboard;
